import {HUES} from './daypart';

/** The hue of the topic with this 1-based number: each number cycles through the palette in turn. */
export const topicHue = (number: number): number =>
    HUES[(((number - 1) % HUES.length) + HUES.length) % HUES.length] ?? HUES[0];

const LIGHT_HUES: readonly number[] = [24, 40, 190, 205];

/** The text colour for a disc of this hue: navy on the light hues, white on the dark ones. */
export const badgeInk = (hue: number): string => (LIGHT_HUES.includes(hue) ? '#12172b' : '#ffffff');
